import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getDocs, query, where, collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import product_icon from "../../assets/product_icon.png";
import { IoReceiptOutline } from "react-icons/io5";
import { MdClose, MdStar, MdStarBorder } from "react-icons/md";
import { Add_favorites } from "../../body_root/add_favorites.js";

export default function Voucher_data() {

    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const [vouchers_masterdata, setVouchers_masterdata] = useState([]);
    const [IsLoading2, setIsLoading2] = useState(true);
    const servicetablename = "accountingfinancedb";
    useEffect(() => {
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid || !guid) return;

        setIsLoading2(true);

        try {
            // Correct query with where()
            const vouchersRef = collection(
                db,
                servicetablename,
                select_company_uid,
                "vouchers"
            );

            const q = query(
                vouchersRef,
                where("usecase_type", "==", false),
                where("entry_type", "==", true)
            );

            // Listen for real-time updates
            const unsubscribe = onSnapshot(q, async (snap) => {
                const voucherPromises = snap.docs.map(async (docSnap) => {
                    const data = docSnap.data();
                    const vid = data.voucherid;
                    if (!vid) return null;

                    // Check favorites
                    const faQuery = query(
                        collection(db, servicetablename, select_company_uid, "favorites"),
                        where("docuid", "==", vid),
                        where("guid", "==", guid),
                        where("status", "==", true)
                    );

                    const faSnap = await getDocs(faQuery);

                    return {
                        id: docSnap.id,
                        ...data,
                        favorites: !faSnap.empty,
                    };
                });

                const results = await Promise.all(voucherPromises);

                setVouchers_masterdata(results.filter(Boolean));
                setIsLoading2(false);
            });

            return () => unsubscribe();
        } catch (err) {
            console.error("Error fetching data:", err);
            Toastshow("Error loading vouchers");
            setIsLoading2(false);
        }
    }, []);
    const set_favorites = async (docuid) => {
        const result = await Add_favorites({ docuid, favorites_type: "voucher" });
        if (result.success) {
            Toastshow("Successfully saved.");

            // Update local state to toggle favorite
            setVouchers_masterdata(prev =>
                prev.map(v =>
                    v.voucherid === docuid
                        ? { ...v, favorites: !v.favorites }
                        : v
                )
            );
        } else {
            Toastshow(result.error || "Failed to save");
        }
    };

    const openEditVoucher = (slug) => {
        navigate(`/?page=voucher_entry&slug=${slug}`, { state: { slug } });
    };

    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div className="button-ui0 text-h2 bold p-2">
                                    <IoReceiptOutline className="icon" />Vouchers list
                                </div>
                            </td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="post-container">
                <div className="post_div p-1">
                    <div className="ui-grid">

                        {vouchers_masterdata.map((row) => (
                            <div
                                key={row.id}
                                title={row.voucher}
                                className="ui-items cursor b-1 p-1 rounded flex"
                            >
                                <table onClick={() => openEditVoucher(row.slug)}>
                                    <tbody>
                                        <tr>
                                            <td width={40}>
                                                <img
                                                    src={row.icon_url || product_icon}
                                                    alt="Img"
                                                    className="icon-img"
                                                />
                                            </td>
                                            <td>
                                                <div className="text-h2 bold fcap">{row.voucher}</div>
                                                <div className="text-h3 text-off">{row.description}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                {row.favorites ? (
                                    <MdStar
                                        onClick={() => set_favorites(row.voucherid)}
                                        className="icon m-2 green"
                                    />
                                ) : (
                                    <MdStarBorder
                                        onClick={() => set_favorites(row.voucherid)}
                                        className="icon m-2"
                                    />
                                )}
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </div>
    );
}
